(function () {
  var track = document.getElementById('vx-category-track');
  if (!track) return;
  var carousel = track.closest('.vx-category-carousel');
  var controls = carousel.querySelector('.vx-category-bar-controls');
  var previous = carousel.querySelector('.vx-category-prev');
  var next = carousel.querySelector('.vx-category-next');

  function updateControls() {
    var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
    controls.hidden = maximum <= 1;
    previous.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= maximum - 1;
  }
  function move(direction) {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({left: direction * Math.max(180, track.clientWidth * 0.8), behavior: reducedMotion ? 'auto' : 'smooth'});
  }
  previous.addEventListener('click', function () { move(-1); });
  next.addEventListener('click', function () { move(1); });
  track.addEventListener('scroll', updateControls, {passive: true});
  track.addEventListener('keydown', function (event) {
    if (event.target !== track) return;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      move(event.key === 'ArrowLeft' ? -1 : 1);
    } else if (event.key === 'Home' || event.key === 'End') {
      event.preventDefault();
      track.scrollLeft = event.key === 'Home' ? 0 : track.scrollWidth;
    }
  });
  window.addEventListener('resize', updateControls);
  if ('ResizeObserver' in window) new ResizeObserver(updateControls).observe(track);
  updateControls();
})();
